import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  a {
    font-family: DM Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #4339F2;
    text-decoration: none;
  }

  body {
    background-color: var(--color-background);
    color: ${(props) => props.theme.colors.text};
    font-family: DM Sans;
  }

  h1 {
    font-family: DM Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 40px;
    line-height: 40px;
    @media (max-width: 768px) {
      font-size: calc(0.8*40px);
    
  }
  }

  h2 {
    font-family: DM Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 22px;
  }

  h3 {
    font-family: DM Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 20px;
    @media (max-width: 768px) {
      font-size: calc(0.8*20px);
    
  }
  }

  h4 {
    font-family: DM Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 0px;
  }

  h5 {
    font-family: DM Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 10px;
    margin-bottom: 0px;
  }

  input {
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
  }

  :root {
    --color-background: #F2F2F2;
    --color-white: #FFF;
    --color-black: #000;
    --color-gray: #F8F8F8;
    --color-blue: #4339F2;
    --color-green: #34B53A;
    --color-red: #F22727;
    --color-input: #c2d6c9;
    --color-selected: #666666;
  }
`;
